var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 33,
    viewBox: "0 0 53 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.4991 16.4895C41.4982 16.8267 41.2241 17.0993 40.8869 17.0984L11.2997 17.0168C10.9625 17.0159 10.6899 16.7418 10.6908 16.4046C10.6917 16.0674 10.9658 15.7948 11.303 15.7958L40.8902 15.8773C41.2274 15.8782 41.5 16.1523 41.4991 16.4895Z",
    fill: "#D7DEDB",
    stroke: "#D7DEDB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6225 1.22175C25.8609 0.983324 26.2475 0.983324 26.4859 1.22175L41.3203 16.0561C41.5587 16.2945 41.5587 16.6811 41.3203 16.9195L26.5674 31.6724C26.329 31.9108 25.9424 31.9108 25.704 31.6724C25.4656 31.4339 25.4656 31.0474 25.704 30.8089L40.0251 16.4878L25.6225 2.08518C25.3841 1.84675 25.3841 1.46018 25.6225 1.22175Z",
    fill: "#D7DEDB",
    stroke: "#D7DEDB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.f4784d6a772816598794e632172b65cc.svg";
export { ForwardRef as ReactComponent };